import React from "react";
import { Table, TableCell, TableRow, Grid } from "@material-ui/core";
import { PaymentSchedule } from "../../../graphql/payment_schedule.datatypes";
import { BillingParty } from "../../../graphql/billing_party.datatypes";
import { formatMoney } from "../../../utils/formatters";
interface DataDisplayProps {
    title: string;
    value: string | number | undefined;
}
interface PaymentScheduleDetailsProps {
    paymentSchedule: PaymentSchedule;
    billingParty: BillingParty;
}

const DataDisplay = (props: DataDisplayProps) => {
    const { title, value } = props;
    return (
        <div>
            <div style={{ fontWeight: "bolder", textDecoration: "underline" }}>
                {title}
            </div>
            <div>{value}</div>
        </div>
    );
};

const PaymentScheduleDetails = (props: PaymentScheduleDetailsProps) => {
    const { paymentSchedule, billingParty } = props;

    const { outstandingBalance, members } = billingParty;
    const numberOfMembers = members ? members.length : 1;
    const finalBalance = outstandingBalance ? outstandingBalance : 0;

    const endingPayments = paymentSchedule.dates.filter(
        date =>
            // date.action_type === 1 ||
            // date.action_type === 2 ||
            date.amount_type === 4
    );

    const castNumber = (amount: number | undefined) => {
        if (!amount) return 0;
        return amount;
    };

    const calcAmount = (amount: number | undefined) => {
        if (!amount) return 0;
        return amount * numberOfMembers;
    };

    return (
        <Grid item xs={12}>
            <Table>
                {paymentSchedule.payment_dates &&
                    paymentSchedule.payment_dates.map(paymentDate => (
                        <TableRow key={paymentDate.id}>
                            <TableCell>
                                <DataDisplay
                                    title="Title"
                                    value={paymentDate.title}
                                />
                            </TableCell>
                            <TableCell>
                                <DataDisplay
                                    title="Due by / Cancel on"
                                    value={paymentDate.due_date}
                                />
                            </TableCell>
                            <TableCell>
                                <DataDisplay
                                    title="Amount / Traveler"
                                    value={formatMoney(
                                        castNumber(paymentDate.amount),
                                        true
                                    )}
                                />
                            </TableCell>
                            <TableCell>
                                <DataDisplay
                                    title="Total Amount"
                                    value={formatMoney(
                                        calcAmount(paymentDate.amount),
                                        true
                                    )}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
            </Table>

            {endingPayments &&
                endingPayments.map(paymentDate => (
                    <TableRow key={paymentDate.id}>
                        {paymentDate.amount_type === 4 && (
                            <TableCell>
                                <DataDisplay
                                    title={paymentDate.title || ""}
                                    value={formatMoney(finalBalance, true)}
                                />
                            </TableCell>
                        )}
                        {paymentDate.amount_type === 4 && (
                            <TableCell>
                                <DataDisplay
                                    title="Due by / Cancel on"
                                    value={paymentDate.due_date}
                                />
                            </TableCell>
                        )}

                        {paymentDate.amount_type === 4 && (
                            <TableCell>
                                <div>&nbsp;</div>
                            </TableCell>
                        )}
                        {paymentDate.amount_type === 4 && (
                            <TableCell>
                                <div>&nbsp;</div>
                            </TableCell>
                        )}

                        {paymentDate.amount_type !== 4 && (
                            <TableCell>
                                <DataDisplay
                                    title={paymentDate.title || ""}
                                    value={formatMoney(
                                        castNumber(paymentDate.amount),
                                        true
                                    )}
                                />
                            </TableCell>
                        )}
                    </TableRow>
                ))}

            {endingPayments.length === 0 && (
                <TableRow>
                    <TableCell>
                        <DataDisplay
                            title="Final Payment"
                            value={formatMoney(finalBalance, true)}
                        />
                    </TableCell>
                </TableRow>
            )}
        </Grid>
    );
};

export default PaymentScheduleDetails;
